export const OPEN = 'OPEN';
export const CLOSED = 'CLOSED';